export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const top = target.getBoundingClientRect().top + window.pageYOffset - 64;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-primary-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-film-line text-white text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold whitespace-nowrap">51动漫网</span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed">
              你的动漫资源终点站。日漫国漫韩漫高清下载，免费、高速、安全。每日更新，全集收录，离线缓存随时看。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">快速导航</h4>
            <div className="space-y-2.5">
              {[
                { label: '热门话题', href: '#topics' },
                { label: '下载排行', href: '#ranking' },
                { label: '常见问题', href: '#faq' },
                { label: '关于我们', href: '#about' },
              ].map((item) => (
                <div key={item.label}>
                  <a
                    href={item.href}
                    onClick={(e) => handleNavClick(e, item.href)}
                    className="text-white/50 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">资源分类</h4>
            <div className="space-y-2.5">
              {['日漫资源', '国漫资源', '韩漫资源', '剧场版动画', '经典老番'].map((item) => (
                <div key={item}>
                  <span className="text-white/50 text-sm whitespace-nowrap">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">合作伙伴</h4>
            <div className="space-y-2.5">
              <p className="text-white/50 text-sm">
                多家知名字幕组与动漫社区携手共建，持续为动漫爱好者提供优质服务。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            &copy; 2019-2026 51动漫网. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <div className="w-8 h-8 flex items-center justify-center cursor-pointer">
              <i className="ri-weibo-line text-white/40 hover:text-primary-400 text-lg transition-colors"></i>
            </div>
            <div className="w-8 h-8 flex items-center justify-center cursor-pointer">
              <i className="ri-wechat-line text-white/40 hover:text-primary-400 text-lg transition-colors"></i>
            </div>
            <div className="w-8 h-8 flex items-center justify-center cursor-pointer">
              <i className="ri-bilibili-line text-white/40 hover:text-primary-400 text-lg transition-colors"></i>
            </div>
            <div className="w-8 h-8 flex items-center justify-center cursor-pointer">
              <i className="ri-github-line text-white/40 hover:text-primary-400 text-lg transition-colors"></i>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}